/* The Rugs :: guide article extra blocks. FAQ accordion, block placement, finder, rail geometry. */
(function () {
  var root = document.querySelector('[data-ag-root]');
  if (!root) return;
  var body = root.querySelector('[data-ag-body]');

  var FAQ_RE = /(people\s+also\s+ask|frequently\s+asked|common\s+questions|questions\s+answered|q\s*&\s*a\b|\bfaqs?\b)/i;
  var HEADING = /^H[1-6]$/;
  var OURS = '.ag-slot,.ag-faq,.ag-finder,.ag-poll,.ag-cpicks,.ag-mt,.ag-picks,.ag-key';
  var BLOCKS = 'h1,h2,h3,h4,h5,h6,p,ul,ol,table,blockquote';

  function flatten() {
    if (!body) return;
    var guard = 0, changed = true;
    while (changed && guard < 12) {
      changed = false; guard++;
      var wraps = body.querySelectorAll('div, section, article, header, footer, main, aside, figure, span');
      for (var i = 0; i < wraps.length; i++) {
        var d = wraps[i];
        if (!d.parentNode || d.closest(OURS)) continue;
        if (d.tagName === 'SPAN' && d.parentNode !== body) continue;
        if (!d.querySelector(BLOCKS)) continue;
        while (d.firstChild) d.parentNode.insertBefore(d.firstChild, d);
        d.parentNode.removeChild(d);
        changed = true;
      }
    }
    Array.prototype.forEach.call(body.querySelectorAll('meta, style, script'), function (m) {
      if (m.parentNode) m.parentNode.removeChild(m);
    });
  }

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function levelOf(el) { return HEADING.test(el.tagName) ? parseInt(el.tagName.slice(1), 10) : 7; }
  function boldOnly(el) {
    if (el.tagName !== 'P') return false;
    var s = el.querySelector('strong, b');
    if (!s) return false;
    var t = text(el);
    return t.length > 0 && text(s).length >= t.length - 2;
  }
  function isQuestion(el) {
    if (!el || el.nodeType !== 1) return false;
    var t = text(el);
    if (t.length < 7 || t.slice(-1) !== '?') return false;
    return HEADING.test(el.tagName) || boldOnly(el);
  }
  function isFaqHeading(el) {
    if (!el || el.nodeType !== 1 || isQuestion(el)) return false;
    var t = text(el);
    if (!FAQ_RE.test(t) || t.length > 70) return false;
    return HEADING.test(el.tagName) || boldOnly(el);
  }
  function isEmpty(el) { return text(el) === '' && !el.querySelector('img, iframe, video'); }
  function isTrailingLinks(kids, from) {
    for (var j = from; j < kids.length; j++) {
      var n = kids[j];
      if (isEmpty(n)) continue;
      if (n.tagName === 'P') {
        var a = n.querySelector('a');
        if (a && text(a).length >= text(n).length - 2) continue;
        if (boldOnly(n)) continue;
      }
      return false;
    }
    return true;
  }

  function scan(kids, from, stopLevel) {
    var pairs = [], consumed = [], current = null, j = from;
    for (; j < kids.length; j++) {
      var n = kids[j];
      if (n.closest(OURS)) break;
      if (isQuestion(n)) { current = { q: text(n), a: [] }; pairs.push(current); consumed.push(n); continue; }
      if (HEADING.test(n.tagName) && levelOf(n) <= stopLevel) break;
      if (boldOnly(n) && current) break;
      if (isEmpty(n)) { consumed.push(n); continue; }
      if (!current) { if (HEADING.test(n.tagName)) break; continue; }
      current.a.push(n);
      consumed.push(n);
    }
    var reachesEnd = j >= kids.length || isTrailingLinks(kids, j);
    return { pairs: pairs, consumed: consumed, end: j, reachesEnd: reachesEnd };
  }

  function render(pairs) {
    var wrap = document.createElement('div');
    wrap.className = 'ag-faq';
    pairs.forEach(function (p) {
      var item = document.createElement('div');
      item.className = 'ag-faq__item';
      item.setAttribute('data-ag-faq-item', '');
      item.setAttribute('data-open', 'false');
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'ag-faq__q'; btn.setAttribute('aria-expanded', 'false');
      var qs = document.createElement('span'); qs.textContent = p.q;
      var sign = document.createElement('span'); sign.className = 'ag-faq__sign'; sign.setAttribute('aria-hidden', 'true'); sign.textContent = '+';
      btn.appendChild(qs); btn.appendChild(sign);
      var ans = document.createElement('div'); ans.className = 'ag-faq__a';
      p.a.forEach(function (node) { ans.appendChild(node); });
      item.appendChild(btn); item.appendChild(ans);
      wrap.appendChild(item);
    });
    return wrap;
  }

  function buildFaq() {
    if (!body) return;
    flatten();
    var kids = Array.prototype.slice.call(body.children);
    var i = 0;
    while (i < kids.length) {
      var el = kids[i];
      if (el.closest(OURS) || el.getAttribute('data-ag-faq-done')) { i++; continue; }
      var result = null, anchorAfter = null, minPairs = 3;
      if (isFaqHeading(el)) {
        result = scan(kids, i + 1, levelOf(el)); anchorAfter = el; minPairs = 1;
      } else if (isQuestion(el)) {
        result = scan(kids, i, levelOf(el)); anchorAfter = el.previousElementSibling;
        if (result.reachesEnd) minPairs = 2;
      }
      if (result && result.pairs.length >= minPairs) {
        var wrap = render(result.pairs);
        var first = result.consumed[0];
        first.parentNode.insertBefore(wrap, first);
        result.consumed.forEach(function (c) { if (c.parentNode && !wrap.contains(c)) c.parentNode.removeChild(c); });
        if (anchorAfter && anchorAfter.setAttribute) anchorAfter.setAttribute('data-ag-faq-done', '1');
        root.setAttribute('data-ag-faq-count', String(result.pairs.length));
        kids = Array.prototype.slice.call(body.children);
        i = kids.indexOf(wrap) + 1;
        continue;
      }
      i++;
    }
  }

  function wireFaq() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ag-faq-item]'), function (item) {
      var q = item.querySelector('.ag-faq__q');
      if (!q || q.getAttribute('data-ag-wired')) return;
      q.setAttribute('data-ag-wired', '1');
      q.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var s = q.querySelector('.ag-faq__sign');
        if (s) s.textContent = open ? '+' : '\u2212';
      });
    });
  }

  try { buildFaq(); wireFaq(); } catch (e) { if (window.console) console.warn('ag faq', e); }

  var RESET = [['height','auto'],['min-height','0'],['max-height','none'],['line-height','1.35'],['text-transform','none'],['letter-spacing','0'],['white-space','normal'],['position','static'],['box-shadow','none'],['overflow','visible'],['flex','0 0 auto']];
  function hardReset(el, extra) {
    for (var i = 0; i < RESET.length; i++) el.style.setProperty(RESET[i][0], RESET[i][1], 'important');
    if (extra) for (var k in extra) el.style.setProperty(k, extra[k], 'important');
  }
  function resetAll() {
    var nav = root.querySelector('.ag-toc__nav');
    if (nav) {
      // No inline display here (16/10/2026): an inline display:flex !important beat every stylesheet rule, so the contents
      // toggle flipped to "+" but the list never hid. article-guide-blocks.css sets the flex and the collapsed state.
      nav.style.setProperty('flex-direction', 'column', 'important');
      nav.style.setProperty('align-items', 'stretch', 'important');
      nav.style.setProperty('max-height', 'none', 'important');
      nav.style.setProperty('overflow', 'visible', 'important');
      nav.style.setProperty('gap', '0', 'important');
    }
    Array.prototype.forEach.call(root.querySelectorAll('.ag-toc__item'), function (el) {
      hardReset(el, { display: 'grid', 'grid-template-columns': 'auto minmax(0,1fr)', 'column-gap': '9px', 'align-items': 'center', padding: '6px 10px', margin: '0', width: '100%', 'text-align': 'left', 'font-size': '12.5px', 'flex-shrink': '0', 'flex-grow': '0', 'flex-basis': 'auto' });
      var num = el.children[0], label = el.children[1];
      if (num) { num.style.setProperty('line-height', '1.35', 'important'); num.style.setProperty('font-size', '10px', 'important'); }
      if (label) {
        if (!el.title) el.title = label.textContent.trim();
        label.style.setProperty('display', 'block', 'important');
        label.style.setProperty('min-width', '0', 'important');
        label.style.setProperty('line-height', '1.35', 'important');
        label.style.setProperty('white-space', 'nowrap', 'important');
        label.style.setProperty('overflow', 'hidden', 'important');
        label.style.setProperty('text-overflow', 'ellipsis', 'important');
      }
    });
    Array.prototype.forEach.call(root.querySelectorAll('.ag-btn'), function (el) { hardReset(el, { display: 'flex', 'align-items': 'center' }); });
    // A poll option must stay the containing block of its result bar (.ag-poll__fill, absolute, top/bottom 0). The reset's
    // position:static let the bar escape after a vote and paint a full-height strip down the page (13/10/2026).
    Array.prototype.forEach.call(root.querySelectorAll('.ag-poll__opt'), function (el) { hardReset(el, { display: 'flex', 'align-items': 'center', position: 'relative', overflow: 'hidden' }); });
    Array.prototype.forEach.call(root.querySelectorAll('.ag-faq__q'), function (el) { hardReset(el, { display: 'flex', 'align-items': 'center', padding: '18px 20px', 'text-align': 'left', width: '100%' }); });
    Array.prototype.forEach.call(root.querySelectorAll('.ag-finder__opt'), function (el) { hardReset(el, { display: 'inline-flex', 'align-items': 'center' }); });
  }

  if (body) {
    var h2s = Array.prototype.filter.call(body.querySelectorAll('h2'), function (h) { return text(h).length > 0 && !h.closest(OURS); });
    var slots = root.querySelectorAll('[data-ag-slot]');
    Array.prototype.forEach.call(slots, function (block) {
      var n2 = parseInt(block.getAttribute('data-ag-slot') || '0', 10);
      block.hidden = false;
      if (n2 > 0 && h2s.length > n2) h2s[n2].parentNode.insertBefore(block, h2s[n2]);
      else body.appendChild(block);
    });
  }

  var finder = root.querySelector('[data-ag-finder]');
  if (finder) {
    var cfg = null;
    try { cfg = JSON.parse(finder.getAttribute('data-ag-finder') || '{}'); } catch (e) { cfg = null; }
    if (!cfg || !cfg.q1 || !cfg.q2) {
      var slot = finder.closest('.ag-slot');
      if (slot) slot.style.display = 'none';
    } else {
      var state = { q1: cfg.q1.default || (cfg.q1.options || [])[0] || '', q2: cfg.q2.default || (cfg.q2.options || [])[0] || '' };
      var set = function (sel, t) { var el = finder.querySelector(sel); if (el) el.textContent = t || ''; };
      set('[data-ag-finder-kicker]', cfg.kicker);
      set('[data-ag-finder-heading]', cfg.heading);
      set('[data-ag-finder-q1label]', cfg.q1.label || 'Step 1');
      set('[data-ag-finder-q2label]', cfg.q2.label || 'Step 2');
      var build = function (key, host) {
        if (!host) return;
        host.innerHTML = '';
        (cfg[key].options || []).forEach(function (opt) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'ag-finder__opt'; b.textContent = opt;
          b.setAttribute('data-ag-finder-q', key); b.setAttribute('data-ag-finder-opt', opt); b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { state[key] = opt; paint(); });
          host.appendChild(b);
        });
      };
      build('q1', finder.querySelector('[data-ag-finder-q1opts]'));
      build('q2', finder.querySelector('[data-ag-finder-q2opts]'));
      var titleEl = finder.querySelector('[data-ag-finder-title]');
      var whyEl = finder.querySelector('[data-ag-finder-why]');
      var ctaEl = finder.querySelector('[data-ag-finder-cta]');
      var cta2El = finder.querySelector('[data-ag-finder-cta2]');
      var resolve = function () {
        var rules = cfg.rules || [];
        for (var i = 0; i < rules.length; i++) {
          var w = rules[i].when || {};
          if (w.q1 && w.q1 !== state.q1) continue;
          if (w.q2 && w.q2 !== state.q2) continue;
          return rules[i];
        }
        return cfg.fallback || {};
      };
      var paint = function () {
        var r = resolve();
        if (titleEl) titleEl.textContent = r.title || '';
        if (whyEl) whyEl.textContent = r.why || '';
        if (ctaEl) { ctaEl.textContent = r.cta || 'Shop now'; ctaEl.href = r.url || '#'; }
        if (cta2El) {
          var l2 = r.cta2 || (cfg.secondary && cfg.secondary.label);
          var u2 = r.url2 || (cfg.secondary && cfg.secondary.url);
          if (l2 && u2) { cta2El.textContent = l2; cta2El.href = u2; cta2El.hidden = false; } else { cta2El.hidden = true; }
        }
        Array.prototype.forEach.call(finder.querySelectorAll('[data-ag-finder-opt]'), function (b) {
          var key = b.getAttribute('data-ag-finder-q');
          b.setAttribute('aria-pressed', state[key] === b.getAttribute('data-ag-finder-opt') ? 'true' : 'false');
        });
      };
      paint();
    }
  }

  function again() { try { buildFaq(); wireFaq(); } catch (e) {} resetAll(); }
  resetAll();
  document.addEventListener('DOMContentLoaded', again);
  window.addEventListener('load', again);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resetAll);
  setTimeout(again, 400);
  setTimeout(resetAll, 1400);
})();
